import { render, staticRenderFns } from "./FormSharedAccess.vue?vue&type=template&id=75ef27c1&"
import script from "./FormSharedAccess.vue?vue&type=script&lang=js&"
export * from "./FormSharedAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75ef27c1')) {
      api.createRecord('75ef27c1', component.options)
    } else {
      api.reload('75ef27c1', component.options)
    }
    module.hot.accept("./FormSharedAccess.vue?vue&type=template&id=75ef27c1&", function () {
      api.rerender('75ef27c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shared-access/form/FormSharedAccess.vue"
export default component.exports